const levelValues = [
  [1, 0, 99, 5, 0, 0, 1, '1 per size'],
  [1, 100, 299, 13, 0, 1, 1, '1 per size'],
  [1, 300, 699, 20, 0, 1, 2, '2 per size'],
  [1, 700, 1499, 32, 0, 2, 3, '3 per size'],
  [1, 1500, 3499, 50, 0, 3, 5],
  [1, 3500, 1000000, 80, 0, 5, 7],
  [2, 0, 99, 13, 0, 1, 1],
  [2, 100, 299, 32, 0, 2, 3],
  [2, 300, 699, 50, 0, 3, 5],
  [2, 700, 1499, 80, 0, 5, 7],
  [2, 1500, 3499, 125, 0, 7, 10],
  [2, 3500, 1000000, 200, 0, 10, 14],
  [3, 0, 99, 20, 0, 1, 2],
  [3, 100, 299, 50, 0, 3, 5],
  [3, 300, 699, 80, 0, 5, 7],
  [3, 700, 1499, 125, 0, 7, 10],
  [3, 1500, 3499, 200, 0, 10, 14],
  [3, 3500, 1000000, 315, 0, 15, 21],
];

const aqlLevels = [];
for (let i = 0; i < levelValues.length; i++) {
  const v = levelValues[i];
  const aqlLevel = {
    id: i + 1,
    selection_level: v[0],
    qty_min: v[1],
    qty_max: v[2],
    sample_qty: v[3],
    critical: v[4],
    major: v[5],
    minor: v[6],
  };
  if (v.length > 7) {
    aqlLevel['qty_to_measure'] = v[7];
  }
  aqlLevels.push(aqlLevel);
}

module.exports = {
  AQL_LEVELS: aqlLevels,
};
